// DiscountType.js
import React, { useState, useEffect } from 'react';
import AppStrings from '../config/appstring';

const DiscountType = ({ value, onChange }) => {
  const [classOptions, setClassOptions] = useState([]); // To store class options fetched from the API

  useEffect(() => {
    const fetchClassDetails = async () => {
      try {
        const response = await fetch(AppStrings.FeesDiscount);
        const data = await response.json(); // Assuming the response is in JSON format

        if (data.success === 200 && Array.isArray(data.data)) {
          setClassOptions(data.data); // Set the class options
        } else {
          console.error('Invalid data format received:', data);
        }
      } catch (error) {
        console.error('Error fetching class details:', error);
      }
    };

    fetchClassDetails();
  }, []);

  return (
    <div>
      <div className="coolinput">
        <select
          style={{ height: '40px' }}
          name="PLACE"
          value={value}
          onChange={(e) => onChange(e.target.value)} // 🔧 Fix applied here
          className="input"
          autoComplete="off"
        >
          <option value="">SELECT</option>
          {classOptions.map((classItem, index) => (
            <option key={index} value={classItem.DISCOUNTTYPE}>
              {classItem.DISCOUNTTYPE || ''}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default DiscountType;
